import { render, staticRenderFns } from "./user-feedback.vue?vue&type=template&id=525ea4da"
import script from "./user-feedback.vue?vue&type=script&lang=ts"
export * from "./user-feedback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports